<template>
    <!-- 圓形小icon -->
    <div class="store">
        <div v-for="(item, index) in list" :key="index">
<!--            <slot name="avatar">-->
                <div :class="small? 'avatar-small':'avatar'">
                    <el-image :src="item.imgUrl" fit="cover" ></el-image>
                </div>
<!--            </slot>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "StoreIcon",
        props: ['list', 'small'],
        data() {
            return {}
        },
        created() {

        },
        mounted() {

        },
        methods: {

        }
    }
</script>

<style lang="less" scoped>
    .store {
        display: flex;
        width: 100%;
        justify-content: space-around;

        .avatar {
            width: 85px;
            height: 85px;
            border: 1px solid #D4D5D5;
            border-radius: 85px;
            overflow: hidden;

            .el-image{
                width: 100%;
                height: 100%;
                border-radius: 85px;
                //object-fit: cover;
            }
        }

        .avatar-small {
            width: 55px;
            height: 55px;
            margin-right: 5px;
            border: 1px solid #D4D5D5;
            border-radius: 85px;
            overflow: hidden;

            .el-image{
                width: 100%;
                height: 100%;
                border-radius: 55px;
                //object-fit: cover;
            }
        }

        .info {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            width: 85px;
            height: 38px;
            font-size: 14px;
            line-height: 19px;
            margin-top: 8px;
            text-align: center;
        }
    }
</style>